import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/suspended',
}).lazy(() => import('./suspended.lazy').then((d) => d.Route))
